<template>
  <div class="bg"
       ref="bigbox">
    <div class="mask"
         v-if="hideMask">
      <div>加载中...</div>
      <div class="loading">
        <div class="jindu"
             :style="{ width: jindu+'%'} "></div>
      </div>
    </div>
    <div class="box">
      <swiper :options="swiperOption"
              class="swiper">
        <swiper-slide v-for="(item,index) in slideData"
                      :key="index"
                      class="swiper-slide">
          <img :src="item.imgLink"
               class="img" />
          <div class="word">{{item.word}}</div>
        </swiper-slide>
      </swiper>
      <!-- <div class="swiper-pagination"></div> -->
    </div>
    <div class="bottom">
      <i>© 重本紫藤教育科技（广州）有限公司 版权所有。</i>
      <a class="beian"
         href="https://beian.miit.gov.cn">粤ICP备2021074338号</a>
      <!-- | 本公司荣获SGS的ISO9001:2008认证 | 增值电信业务经营许可证：粤B2-20170231 Copyright (C) 2002-2018 |
      <a class="beian"
         href="https://gdca.miit.gov.cn/">广东省通信管理局</a> -->
    </div>
  </div>
</template>

<script>
import api from '@/api'
const wx = require('weixin-js-sdk')
export default {
  mounted () {
    document.title = "重本·紫藤 毕业生电子相册"
    this.setShare()
  },
  created () {
    this.timer = setInterval(() => {
      console.log(document.readyState)
      console.log(this.jindu)
      if (this.jindu < 100) {
        this.jindu = this.jindu + 5
      }
      if (document.readyState === 'complete') {
        window.clearInterval(this.timer)
        this.hideMask = false
      }
    }, 1000)
  },
  data () {
    return {
      jindu: 0,
      hideMask: true,
      timer: null, // 定时器
      slideData: [
        {
          imgLink: require('../assets/img/毕业照/1.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-1班'
        },
        {
          imgLink: require('../assets/img/毕业照/1-2.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-1班'
        },
        {
          imgLink: require('../assets/img/毕业照/2.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-2班'
        },
        {
          imgLink: require('../assets/img/毕业照/2-2.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-2班'
        },
        {
          imgLink: require('../assets/img/毕业照/3.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-3班'
        },
        {
          imgLink: require('../assets/img/毕业照/3-2.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-3班'
        },
        {
          imgLink: require('../assets/img/毕业照/3-3.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-3班'
        },
        {
          imgLink: require('../assets/img/毕业照/3-3.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-3班'
        },
        {
          imgLink: require('../assets/img/毕业照/4.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-4班'
        },
        {
          imgLink: require('../assets/img/毕业照/4-2.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-4班'
        },
        {
          imgLink: require('../assets/img/毕业照/4-3.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-4班'
        },
        {
          imgLink: require('../assets/img/毕业照/5-1.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-5班'
        },
        {
          imgLink: require('../assets/img/毕业照/5-2.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-5班'
        },
        {
          imgLink: require('../assets/img/毕业照/5-3.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-5班'
        },
        {
          imgLink: require('../assets/img/毕业照/6.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-6班'
        },
        {
          imgLink: require('../assets/img/毕业照/6-1.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-6班'
        },
        {
          imgLink: require('../assets/img/毕业照/7-1.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-7班'
        },
        {
          imgLink: require('../assets/img/毕业照/7-2.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-7班'
        },
        {
          imgLink: require('../assets/img/毕业照/7-3.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-7班'
        },
        {
          imgLink: require('../assets/img/毕业照/8.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-8班'
        },
        {
          imgLink: require('../assets/img/毕业照/8-2.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-8班'
        },
        {
          imgLink: require('../assets/img/毕业照/8-3.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影-8班'
        },
        {
          imgLink: require('../assets/img/毕业照/教师职工.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/毕业照/教师职工2.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/1.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/2.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/3.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/4.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/5.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/6.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/7.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/8.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/9.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/10.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/11.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/12.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/13.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/14.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/15.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/16.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/17.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/18.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/19.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/20.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/21.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/22.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/23.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/24.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/25.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/26.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/27.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/28.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        },
        {
          imgLink: require('../assets/img/生活照/29.jpg'),
          word: '重本·紫藤中考复读学校2021届   *  班毕业师生合影'
        }
      ],
      swiperOption: {
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        // 自动播放
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        // },
        autoplayDisableOnInteraction: false,
        // 设置轮播
        // effect: 'flip',
        effect: 'slide',
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: 'horizontal',
        // 分页器设置
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          bulletClass: 'my-bullet',
          bulletActiveClass: 'my-bullet-active'
        }
      }
    }
  },
  methods: {
    setShare () {
      let url = 'https://www.zhongbenziteng.com/dzxc-m/index.html' // 显示页面地址
      api.wechat.jsSdkConfig2({ params: { url } }).then(function (res) {
        // 微信小程序接口起调配置
        console.log(res.data.data)
        console.log(wx)
        wx.config({
          debug: false,
          appId: res.data.data.appId,
          timestamp: res.data.data.timestamp,
          nonceStr: res.data.data.noncestr,
          signature: res.data.data.signature,
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'getLocation',
            'openLocation'
          ]
        })
        wx.ready(function () {
          wx.checkJsApi({
            jsApiList: [
              'onMenuShareTimeline',
              'onMenuShareAppMessage'
            ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
              console.log(res)
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            }
          })
          wx.onMenuShareTimeline({
            title: '重本·紫藤 毕业生电子相册', // 分享标题
            // desc: '艺考 更易考', // 分享描述
            link: 'https://www.zhongbenziteng.com/dzxc-m/index.html#/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://boss-prd.oss-cn-shenzhen.aliyuncs.com/otherFile/web/202106/f505dc06-a43f-4799-8bb1-c77c517d78cc.png', // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              alert('分享成功')
            }
          })
          wx.onMenuShareAppMessage({
            title: '重本·紫藤 毕业生电子相册', // 分享标题
            // desc: '艺考 更易考', // 分享描述
            link: 'https://www.zhongbenziteng.com/dzxc-m/index.html#/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://boss-prd.oss-cn-shenzhen.aliyuncs.com/otherFile/web/202106/f505dc06-a43f-4799-8bb1-c77c517d78cc.png', // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              alert('分享成功')
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            }
          })
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bg {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: scroll;
  }

  .img {
    width: 100%;
  }

  .box {
    width: 100%;
    height: 100%;
    /* border-radius: 5px; */
    overflow: hidden;
  }

  .swiper{
    width: 100%;
    height: 100%;
  }

  .word {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 10px;
    width: 100%;
    color: #fff;
    font-size: 14px;
    background-image: linear-gradient(-90deg,rgba(0, 0, 0, .5), rgba(255, 255, 255, .5));
    z-index: 999;
    box-sizing: border-box;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;
    overflow: hidden;
  }
  .img {
    width: 100%;
  }
  
  .swiper-pagination{
    position: absolute;
    top: 0;
    left: 50%;
    width: 100%;
    overflow: hidden;
    transform: translateX(-50%);
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 55px;
    padding: 0 15px;
    background: url('../assets/img/foot-btn.png') no-repeat;
    background-size: 100%;
    box-sizing: border-box;
  }

  .save {
    width: 80px;
    height: 37px;
    border-radius: 19px;
  }

  .rightNow {
    width: 171px;
    height: 37px;
    border-radius: 19px;
  }

  .bottom {
    width: 100%;
    /* margin-bottom: 55px; */
    font-size: 9px;
    /* line-height: 30px; */
    color: #999;
    text-align: center;
    background-color: #4a4a4a;
  }

  .beian {
    color: #999;
    text-decoration: none;
  }

  .beian:hover {
    text-decoration: underline;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #fff;
    background-color: rgba(0, 0, 0, .5);
  }

  .loading {
    position: relative;
    width: 80%;
    height: 10px;
    margin-top: 10px;
    background-color: #fff;
    border: 1px solid white;
    border-radius: 5px;
  }

  .jindu {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 10px;
    /* margin-top: 10px; */
    background-color: #ad7fbb;
    border-radius: 5px;
  }
</style>
<style>
.my-bullet {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 5px;
  background-color: #b2aba1;
  border-radius: 50%;
  opacity: .4;
}

.my-bullet-active {
  background: #fff;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/photo.vue